<template>
    <div>
        <compMutiUpload @on-cancel="$emit('on-close')" v-bind="propsData"></compMutiUpload>
    </div>
</template>
<script>
export default {
    props: ['propsData'],
}
</script>